export default "__VITE_ASSET__DqzM2bBn__"